module.exports = __webpack_public_path__ + "img/icon-google-drive.33280349.png";